import React from 'react';
import { connect } from 'react-redux';
import { useMySearchClock } from 'react/matchmaking/unified/header/searchClock';
import { __ } from 'i18n/index';
import { isTeamLobby } from 'react/match/lobby/describeLobby';

// The player's own search clock (m:ss), or null when not searching. Ticks every
// second, in step with every other reader of the clock.
export function useSearchClock() {
	return useMySearchClock().clock;
}

// Next to the header's Play link: LIVE (red) while the set is played, a muted
// "Set over" once it has ended (until the match is closed), "Disputed" (amber)
// while a dispute is open, else the search timer (gold).
// The match is read here, not in mapStateToProps: the store hears of an
// update before the match object has finished changing in place.
function PlayNavStatusComponent({ currentMatch }) {
	const searchClock = useSearchClock();
	const inMatch = !!currentMatch;
	const disputed = isDisputed(currentMatch);
	const setOver = isSetOver(currentMatch);
	if(disputed) {
		return <span className='netplay-nav-status netplay-nav-status--alert'>{__('Disputed')}</span>;
	}
	if(setOver) {
		return <span className='netplay-nav-status netplay-nav-status--muted'>{__('Set over')}</span>;
	}
	if(inMatch && isTeamLobby(currentMatch)) {
		return <span className='netplay-nav-status netplay-nav-status--lobby'>{__('LOBBY')}</span>;
	}
	if(inMatch) {
		return <span className='netplay-nav-status netplay-nav-status--live'>{__('LIVE')}</span>;
	}
	if(searchClock) {
		return (
			<span className='netplay-nav-status netplay-nav-status--searching' title={__('Searching')}>
				{searchClock}
			</span>
		);
	}
	return null;
}

// Next to the header's Chat link: unread DMs (red).
function ChatNavStatusComponent({ unreadPrivateMessageCount }) {
	if(!unreadPrivateMessageCount) {
		return null;
	}
	return (
		<span className='netplay-nav-status netplay-nav-status--live' title={__('Unread messages')}>
			{unreadPrivateMessageCount > 99 ? '99+' : unreadPrivateMessageCount}
		</span>
	);
}

function isDisputed(currentMatch) {
	return !!currentMatch && typeof currentMatch.disputeIsActive === 'function' && !!currentMatch.disputeIsActive();
}

// Match.isEnded() is also true while a dispute is open; that set isn't over yet.
function isSetOver(currentMatch) {
	return !!currentMatch && typeof currentMatch.isEnded === 'function' && !!currentMatch.isEnded() && !isDisputed(currentMatch);
}

export const PlayNavStatus = connect((state) => ({
	currentMatch: state.matchmaking?.currentMatch || null,
	// The match object is updated in place; the index changes on every update.
	currentMatchUpdateIndex: state.matchmaking?.currentMatchUpdateIndex,
}))(PlayNavStatusComponent);

export const ChatNavStatus = connect((state) => ({
	unreadPrivateMessageCount: state.privateChat?.unreadPrivateMessageCount || 0,
}))(ChatNavStatusComponent);
